export const STICKY_FOOTER_ID = 'sticky-footer';

export type StickyFooterProps = {
  editMode: boolean;
  sitecoreContext: any;
};
